// Server-side UploadStatus values where the /sessions/{uploadId}/claim
// endpoint accepts a takeover. Kept in one place so both takeover surfaces
// (AdminOutcomeDrawer per-outcome row + AdminUploadDiagnosticsDrawer live
// row) render the button under identical conditions. Terminal statuses
// (COMPLETED / CANCELLED / FAILED) are excluded — the contributor's session
// is already gone, nothing to claim. Mirrors server UploadStatus.ACTIVE_STATUSES.
export const ADMIN_TAKEOVER_STATUSES = new Set([
  "PENDING_CHUNKS",
  "CHUNK_UPLOAD_IN_PROGRESS",
  "PAUSED",
  "CHUNK_UPLOAD_ASSEMBLING",
  "READY_TO_UPLOAD_TO_PROVIDER",
  "IN_PROGRESS_UPLOAD_TO_PROVIDER",
  "READY_FOR_CAT_DV",
]);

export const isAdminTakeoverEligible = (status) =>
  !!status && ADMIN_TAKEOVER_STATUSES.has(status);
